var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiLightDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 19.5C18 20.2956 17.6839 21.0587 17.1213 21.6213C16.5587 22.1839 15.7956 22.5 15 22.5H8C7.20435 22.5 6.44129 22.1839 5.87868 21.6213C5.31607 21.0587 5 20.2956 5 19.5V7.5H4V4.5H8.5L9.5 3.5H13.5L14.5 4.5H19V7.5H18V19.5ZM6 7.5V19.5C6 20.0304 6.21071 20.5391 6.58579 20.9142C6.96086 21.2893 7.46957 21.5 8 21.5H15C15.5304 21.5 16.0391 21.2893 16.4142 20.9142C16.7893 20.5391 17 20.0304 17 19.5V7.5H6ZM18 6.5V5.5H14L13 4.5H10L9 5.5H5V6.5H18ZM8 9.5H9V19.5H8V9.5ZM14 9.5H15V19.5H14V9.5Z",
    fill: "#BD001C",
    stroke: "#BD001C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiLightDelete);
export default __webpack_public_path__ + "static/media/mdi-light_delete.c8ac46ee88b24bed1013d581c26f5721.svg";
export { ForwardRef as ReactComponent };